/** Reusable camera fade helpers for transitioning between Phaser scenes. */
import Phaser from 'phaser';

const FADE_DURATION = 500;

/** Fade the camera to black then start the named scene, passing optional data. */
export function fadeToScene(scene: Phaser.Scene, targetScene: string, data?: object): void {
  scene.cameras.main.fadeOut(FADE_DURATION, 0, 0, 0);
  scene.cameras.main.once(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, () => {
    scene.scene.start(targetScene, data);
  });
}

/** Fade the camera in from black for the given scene. */
export function fadeIn(scene: Phaser.Scene): void {
  scene.cameras.main.fadeIn(FADE_DURATION, 0, 0, 0);
}
